// extracted by mini-css-extract-plugin
export default {"rank":"categoryHeader_rank__29+EF"};